import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { BsModalComponent, BsModalService } from 'ng2-bs3-modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '@services/http/auth.service';
import { CachedDataService } from '@services/data/cached-data.service';
import { User } from '@models/user';
import { regexValidators } from '../../../validator';
@Component({
  selector: 'feedback-modal',
  templateUrl: './feedback-modal.component.html'
})

export class FeedbackComponent implements OnInit {

  @ViewChild('feedbackModal')
  feedbackModal: BsModalComponent;
  public user = new User;
  public isAuth = false;
  errorMessage: string = null;
  feedBackForm: FormGroup;
  isSend = false;
  formSubmitAttempt = false;
  isOpen = false;
  trySend = false;
  btnText: any = {
    text: "Отправить",
    defaultText: "Отправить",
    loadText: "Обработка.."
  };

  maskSettings = {
    mask: regexValidators.phone,
    guide: true,
    showMask: false
  };

  constructor(
    private cachedDataService: CachedDataService,
    private authService: AuthService,
    private formBuilder: FormBuilder) {
    cachedDataService.updateUserStatus.subscribe(() => {
      this.isAuth = this.cachedDataService.isAuth();
      this.user = this.cachedDataService.getCurrentUser();
    });
    this.isAuth = this.cachedDataService.isAuth();
    this.user = this.cachedDataService.getCurrentUser();
  }

  ngOnInit() {
    this.initForm();
  }
  initForm() {
    this.isOpen = false;
    this.isSend = false;
    this.formSubmitAttempt = false;
    this.feedBackForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.pattern(regexValidators.email)]],
      text: [null, [Validators.required]],
      numberSim: [null, [Validators.required]],
      modelAlarm: [null, [Validators.required]],
      loginAlarm: [null, [Validators.required]],
      environments: [null]
    });
  }
  open() {
    this.isOpen = true;
    this.errorMessage = null;
    this.feedBackForm.reset();
    if (this.isAuth) {
      this.feedBackForm.controls['name'].clearValidators();
      this.feedBackForm.controls['name'].setErrors(null);
      this.feedBackForm.controls['email'].clearValidators();
      this.feedBackForm.controls['email'].setErrors(null);
    } else {

      this.feedBackForm.controls['numberSim'].setErrors(null);
      this.feedBackForm.controls['numberSim'].clearValidators();

      this.feedBackForm.controls['modelAlarm'].setErrors(null);
      this.feedBackForm.controls['modelAlarm'].clearValidators();

      this.feedBackForm.controls['loginAlarm'].setErrors(null);
      this.feedBackForm.controls['loginAlarm'].clearValidators();
    }

    this.feedbackModal.open();
  }
  isFieldValid(field: string) {
    if (!this.isOpen) {
      return false;
    }
    return (!this.feedBackForm.get(field).valid && this.feedBackForm.get(field).touched) ||
      (this.feedBackForm.get(field).untouched && this.formSubmitAttempt);
  }
  send() {
    if (this.trySend) {
      return false;
    }
    this.formSubmitAttempt = true;
    if (this.feedBackForm.invalid) {
      const controls = this.feedBackForm.controls;
      Object.keys(controls)
        .forEach(controlName => controls[controlName].markAsTouched());
      return;
    }

    this.btnText.text = this.btnText.loadText;
    this.trySend = true;
    let body = null;
    if (this.isAuth) {
      let text = '';
      text += `Номер сим-карты в авто: ${this.feedBackForm.value.numberSim}, `;
      text += `Модель сигнализации: ${this.feedBackForm.value.modelAlarm}, `;
      text += `Логин к сигнализации :${this.feedBackForm.value.loginAlarm}, `;
      text += `Сообщение :${this.feedBackForm.value.text}`;
      body = {
        name: this.user.fullName,
        text: text,
        contacts: {
          email: this.user.email,
          phone: this.user.phoneNumber,
          fullName: this.user.fullName,
          userName: this.user.userName,
        },
        environments: {
          info: window.navigator.userAgent
        }

      };
    } else {
      body = {
        name: this.feedBackForm.value.name,
        text: this.feedBackForm.value.text,
        contacts: {
          email: this.feedBackForm.value.email
        },
        environments: {
          info: window.navigator.userAgent
        }
      };
    }
    this.authService.helpRequest(body)
      .then(() => {
        this.btnText.text = this.btnText.defaultText;
        this.isSend = true;
        this.trySend = false;
        this.feedBackForm.reset();
        setTimeout(() => {
          this.feedbackModal.close();
        }, 5000);
      })
      .catch((error: any) => {
        this.trySend = false;
        this.btnText.text = this.btnText.defaultText;
        if (error.error.errorMessage.length) {
          this.errorMessage = error.error.errorMessage;
        }
      });
  }
  focusMask() {

    if (!this.feedBackForm.controls['numberSim'].value || this.feedBackForm.controls['numberSim'].value.length === 0) {
      setTimeout(() => {
        this.feedBackForm.controls['numberSim'].setValue(' ');
      }, 50);
    }
  }
  onBlurMaskPhone() {
    if (this.feedBackForm.controls['numberSim'].value.indexOf('_') >= 0 || this.feedBackForm.controls['numberSim'].value.length === 1) {
      this.feedBackForm.controls['numberSim'].setValue('');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/view/modal/feedback-modal/feedback-modal.component.ts